// import OurCompanyPage from "./Component/OurCompany";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Leadership from "./pages/Leadership";
import SafetyPolicy from "./pages/SafetyPolicy";
// import Engineering from "./pages/Engineering";
// import Home from "./pages/Home";
import "@fontsource/poppins";
import Comissioning from "./pages/Comissioning";
import Procurement from "./pages/Procurement";
import Marine from "./pages/Marine";
import Construction from "./pages/Construction";
import ManPower from "./pages/ManPower";
import Installment from "./pages/Installment";
import Contact from "./pages/Contact";
// import Projects from "./pages/Projects";
import Career from "./pages/Career";
import { useEffect } from "react";
import { WOW } from "wowjs";
import "animate.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import WebsiteLayout from "./Component/Layout";
import { Layout } from "./Admin/Components/Layout";
import AdminHome from "./Admin/pages/Dashboard";
import Company from "./Admin/pages/Company";
import AdminLeadership from "./Admin/pages/Leadership";
import { AdminTable } from "./Admin/pages/AdminDashboard";
import AdminCareer from "./Admin/pages/Career";
import AdminComissioning from "./Admin/pages/Comissioning";
import AdminConstruction from "./Admin/pages/Construction";
import AdminContact from "./Admin/pages/Contact";
import AdminEngineering from "./Admin/pages/Engineering";
import AdminInstallment from "./Admin/pages/Installment";
import AdminManPower from "./Admin/pages/ManPower";
import AdminMarine from "./Admin/pages/Marine";
import { Login } from "./Admin/pages/Login";
import AdminSafetyPolicy from "./Admin/pages/SafetyPolicy";
import AdminQhse from "./Admin/pages/Qhse";
import AdminPartnership from "./Admin/Components/Partnership";
import AdminTestimonial from "./Admin/Components/AdminTestimony";
import AdminProcurement from "./Admin/pages/Procurement";
import AdminProjects from "./Admin/pages/Projects";
import AdminApplications from "./Admin/pages/Application";
import Homepage from "./pages/HomePage";
import ManagementTeam from "./pages/Management";
import AboutPage from "./pages/Aboutpage";
import ProjectsTable from "./pages/NewProject";
import ServiceDetail from "./pages/NewEngineering";
import QHSE from "./pages/Qhse";
import Csr from "./Admin/pages/Csr";
import CSR from "./pages/Csr";
import ProtectedRoute from "./Admin/Components/ProtectedRoute"; // ✅ import
import ContactMessages from "./Admin/pages/ContactMessage";

function App() {
  useEffect(() => {
    const wow = new WOW({
      mobile: true,
      live: true,
    });
    wow.init();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>

          {/* 🌐 WEBSITE */}
          <Route path="/" element={<WebsiteLayout />}>
            <Route index element={<Homepage />} />
            <Route path="company" element={<Company />} />
            <Route path="our-company" element={<AboutPage />} />
            <Route path="leadership" element={<ManagementTeam />} />
            <Route path="safety" element={<SafetyPolicy />} />
            <Route path="engineering" element={<ServiceDetail />} />
            <Route path="procurement" element={<Procurement />} />
            <Route path="commissioning" element={<Comissioning />} />
            <Route path="construction" element={<Construction />} />
            <Route path="manpower-supply" element={<ManPower />} />
            <Route path="installation-instrumentation" element={<Installment />} />
            <Route path="marine-support" element={<Marine />} />
            <Route path="contact" element={<Contact />} />
            <Route path="projects" element={<ProjectsTable />} />
            <Route path="career" element={<Career />} />
            <Route path="qhse" element={<QHSE />} />
            <Route path="csr" element={<CSR />} />
          </Route>

          {/* 🔑 LOGIN — public */}
          <Route path="/login" element={<Login />} />

          {/* 🔐 ADMIN — all protected by token check */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminHome />} />
            <Route path="company" element={<Company />} />
            <Route path="leadership" element={<AdminLeadership />} />
            <Route path="admin" element={<AdminTable />} />
            <Route path="careers" element={<AdminCareer />} />
            <Route path="contact-mesaaging" element={<ContactMessages />} />
            <Route path="commissioning" element={<AdminComissioning />} />
            <Route path="construction" element={<AdminConstruction />} />
            <Route path="contact" element={<AdminContact />} />
            <Route path="engineering" element={<AdminEngineering />} />
            <Route path="installation-instrumentation" element={<AdminInstallment />} />
            <Route path="manpower-supply" element={<AdminManPower />} />
            <Route path="marine-support" element={<AdminMarine />} />
            <Route path="safety-policy" element={<AdminSafetyPolicy />} />
            <Route path="qhse" element={<AdminQhse />} />
            <Route path="partnership" element={<AdminPartnership />} />
            <Route path="testimoy" element={<AdminTestimonial />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="procurement" element={<AdminProcurement />} />
            <Route path="application" element={<AdminApplications />} />
            <Route path="csr" element={<Csr />} />
          </Route>

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;